
import Vue from "vue";
import AppContactSearch from "./ContactSearchWithBrowse.vue";
import { Contact } from "@/models/base";
import { AllContactsService } from "@/services";

export default Vue.extend({
	data(){
		return {
			contact: null as null | Contact
		};
	},
	props: {
		groupId: {
			type: [Number, Array as () => number[]],
			required: true
		},
		value: {
			type: Number
		},
		label: {
			type: String
		},
		fancy: {
			type: Boolean
		},
		disableCreate: Boolean,
		disabled: Boolean,
		iconLeft: String,
		iconLeftTooltip: [String, Object],
	},
	watch: {
		value: {
			immediate: true,
			async handler(){
				if (typeof(this.value) != "number"){
					this.$emit("input", 0);
					return;
				}
				if (this.value == 0){
					this.contact = null;
				}else if (!this.contact || this.contact.ID != this.value){
					this.contact = await AllContactsService.getContactByID(this.value);
				}
			}
		}
	},
	methods: {
		onNewContact(contact:Contact){
			this.contact = contact;
			if (!this.contact && this.value != 0) {
				this.$emit("input", 0);
				return;
			}
			if (!this.contact) return;
			if (this.contact.ID != this.value) {
				this.$emit("input", this.contact.ID);
			}
		}
	},
	components: {
		AppContactSearch
	}
});
